module.exports = __webpack_public_path__ + "static/media/Øks.de7fdae7.PNG";